import { action } from '@ember/object';
import Component from '@glimmer/component';
import { STATUS_KEYS } from 'scaleflow/models/initiative-update';

export default class InitiativesPopoverInitiativeUpdateIndexComponent extends Component {
  status_keys = STATUS_KEYS;

  @action
  setProgressStatus(status) {
    this.args.item.status = status;
  }

  @action
  setProgressComments(e) {
    this.args.item.text_delta = e;
  }

  @action
  setReportedHealth(val) {
    this.args.item.reported_health = val;
  }

  @action
  cancel() {
    this.args.item.deleteRecord();
    this.args?.deactivateCreatingNew?.();
  }

  @action
  save() {
    this.args.item.save().then(() => {
      this.args?.deactivateCreatingNew?.();
    });
  }

  @action
  deleteItem() {
    this.args.item.destroyRecord();
  }
}
